// batch AI generation subtitle modal
import _ from 'lodash'
export default {
  data() {
    return {
      isBatch: false,
      batchDubTotalPrice: 0,
      batchDubConfig: [],
      batchAllVideosCount: 0,
      loadingConfigs: false,
      batchSubtitles: [],
      accountBalance: 0,
    }
  },
  mounted() {
    this.$root.$on('openBatchDubModal', () => {
      this.$root.$emit('openDubbingModal', {
        videoId: '',
        initialState: true,
        isBatch: true,
      })
    })
    this.$root.$on('batchAllVideosCount', (batchAllVideosCount) => {
      this.batchAllVideosCount = batchAllVideosCount
    })
    this.$root.$on('loadingConfigs', (loadingConfigs) => {
      this.loadingConfigs = loadingConfigs
    })
    this.$root.$on('processQueue', () => {
      this.processDubbingQueue()
    })
    this.$root.$on('handleBatchConfigs', (configuredVideos) => {
      this.handleBatchDubConfigs(configuredVideos)
    })
    this.$root.$on('accountBalance', (accountBalance) => {
      this.accountBalance = accountBalance
    })
  },
  beforeDestroy() {
    this.$root.$off('openBatchDubModal')
    this.$root.$off('batchDubTotalPrice')
    this.$root.$off('batchDubConfig')
    this.$root.$off('batchAllVideosCount')
    this.$root.$off('loadingConfigs')
    this.$root.$off('processQueue')
    this.$root.$off('handleBatchConfigs')
  },
  computed: {
    filterDubsToGenerate() {
      const batchDubConfig = this.batchDubConfig
      let filter = []
      batchDubConfig.map((video) => {
        const filteredLangToGenerate = this.checkExistingDubs(
          this.generateDubbingData,
          video
        )
        if (filteredLangToGenerate) {
          filteredLangToGenerate.length = video.length
          if (video.subtitles.length) {
            filteredLangToGenerate.dubbingFromSubtitle = video.subtitles[0]
            filteredLangToGenerate.dubbingOption = 1
            filteredLangToGenerate.subtitles = video.subtitles
          }
          filteredLangToGenerate.audios = video.audios

          const dubConfig = {
            video_id: video.id,
            folder_id: video.folder_id,
            config: filteredLangToGenerate,
            status: 'pending',
            type: 'dubbing',
          }

          filter.push(dubConfig)
        }
      })
      return filter
    },
    handleExistingDubs() {
      const batchDubConfig = this.batchDubConfig

      for (let video of batchDubConfig) {
        const dubsToGenerate = this.checkExistingDubs(
          this.generateDubbingData,
          video
        )
        if (dubsToGenerate) {
          return false
        }
      }
      return true
    },
  },
  watch: {
    'generateDubbingData.selectedItems'() {
      this.batchDubTotalPrice = this.calcBatchDubTotalPrice()
    },
  },
  methods: {
    async handleOpenBatchDubGenerationModal() {
      this.generateDubbingDataInitial = _.cloneDeep(this.generateDubbingData)
      this.open = true
      this.setUppy()

      if (this.planInfo.currency) {
        if (this.planInfo.currency === 'brl') {
          this.generateDubbingData.dubbingFromVideo = 'pt-BR'
        } else {
          this.generateDubbingData.dubbingFromVideo = 'en'
        }
      }
      this.handleUpdateModalStage({
        globalStage: 'generate',
        subStage: 1,
      })
    },
    checkExistingDubs(dubbingsToGenerate, dubbingObj) {
      const filteredSelectedItems = dubbingsToGenerate.selectedItems
        .filter(
          (selectedItem) =>
            !dubbingObj.audios.some((dub) => dub === selectedItem.srclang)
        )
        .filter((item) => item.srclang !== dubbingsToGenerate.dubbingFromVideo)

      return filteredSelectedItems.length > 0
        ? { ...dubbingsToGenerate, selectedItems: filteredSelectedItems }
        : null
    },
    handleBatchDubConfigs(videos) {
      const batchDubConfig = videos.map((obj) => ({
        id: obj.id,
        folder_id: obj.folder_id,
        length: obj.length,
        subtitles: obj.subtitles ?? [],
        audios: obj.audios ?? [],
      }))
      this.batchDubConfig = batchDubConfig
    },
    handleBatchDubbingOptions() {
      const existingDubbings = this.batchDubConfig.map((obj) => obj.audios)
      const languageOptions = this.availableAiLangCodes

      const commonLanguages = languageOptions
        .filter((option) =>
          existingDubbings.every((audios) => audios.includes(option.srclang))
        )
        .map((option) => option.srclang)

      const filteredLanguageOptions = languageOptions.filter(
        (option) => !commonLanguages.includes(option.srclang)
      )

      return filteredLanguageOptions
    },
    async handleBatchDubGeneration() {
      const dubsToGenerate = this.filterDubsToGenerate
      try {
        dubsToGenerate.map(async (dubConfig) => {
          if (dubConfig) {
            await this.updateDb(dubConfig)
          }
        })
        setTimeout(() => {
          this.processDubbingQueue()
        }, 1700)
      } catch (error) {
        console.error('Error to queue dubbing: ', error)
      }
    },
    async updateDb(dubConfig) {
      await window.db.AI_batch_queue.add(dubConfig)
    },
    async processDubbingQueue() {
      let dubConfig
      let loopCount = 0
      while (
        (dubConfig = await window.db.AI_batch_queue.where({
          status: 'pending',
        }).first())
      ) {
        const hasEnoughCredits = this._hasEnoughCredits(dubConfig.config.length)
        if (!hasEnoughCredits) {
          await window.db.AI_batch_queue.clear()
          return
        }
        try {
          this.videoId = dubConfig.video_id
          this.generateDubbingData = { ...dubConfig.config }
          this.batchSubtitles = dubConfig.config.subtitles
          await this.handlePostDubbing()

          await window.db.AI_batch_queue.update(dubConfig.id, {
            status: 'generating',
          })
          this.$root.$emit('updateGeneratingIds', dubConfig.video_id)
          if (!loopCount) {
            loopCount += 1
            this.$root.$emit('fetchQueueStatus')
          }
        } catch (error) {
          console.error(
            `Error to generate dubbing ${dubConfig.videoId}: `,
            error
          )
          await window.db.AI_batch_queue.update(dubConfig.id, {
            status: 'error',
          })
        }
      }
    },
    calcBatchDubTotalPrice() {
      const dubbingPrice = 1 // was dubbingPrice (PROMOTIONAL)
      const dubToGenerate = this.filterDubsToGenerate

      if (!dubToGenerate.length) return 0

      let dubsToCalc = dubToGenerate.filter((item) => {
        return item.config.audios.length < 3
      })

      if (!dubsToCalc.length) return 0

      dubsToCalc = dubsToCalc.map((item) => item.config)

      let finalPrice = 0

      dubsToCalc.forEach((item) => {
        const selectedDubsToCalc = item.selectedItems.length
        const videoLength = item.length

        const isShortVideo = videoLength < 60

        let totalPrice = 0

        if (isShortVideo) {
          totalPrice = dubbingPrice * selectedDubsToCalc
        } else {
          const videoTimeMinutes = Math.floor(videoLength / 60)
          const remainingSeconds = videoLength % 60

          totalPrice += videoTimeMinutes * dubbingPrice

          if (remainingSeconds > 0) {
            totalPrice += dubbingPrice
          }

          totalPrice *= selectedDubsToCalc
        }

        finalPrice += totalPrice
      })

      return finalPrice
    },
    _hasEnoughCredits(videoLength) {
      const dubbingPrice = 1 // was 5 (PROMOTIONAL)
      function calcPrice() {
        let totalPrice = 0
        let videoTimeMinutes = Math.floor(videoLength / 60)

        if (!videoTimeMinutes) {
          totalPrice = dubbingPrice
          return totalPrice
        }

        let remainingSeconds = videoLength % 60

        totalPrice = videoTimeMinutes * dubbingPrice

        if (remainingSeconds > 0) {
          totalPrice += dubbingPrice
        }

        return totalPrice
      }
      const totalPrice = calcPrice()
      const remainingCredits = this.accountBalance - totalPrice

      if (remainingCredits < 0) {
        return false
      }
      return true
    },
  },
}
